import {
  add
} from "../../commonFunctions";
import { controls } from "../../controls";

const rp003 = {
  label: "Scroll",
  starting: true,
  url: "rp003",
  pageLabel: "Scroll",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Batch No",
      label: "Batch No",
      name: "",
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Batch No",
      label: "",
      name: "batch_number",
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),


    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      label: "Entry By",
      name: "",
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Entry By",
      label: "",
      name: "entry_by",
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Amount From-To",
      name: "",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "amount_from",
      description: ""
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "amount_to",
      description: ""
    },

    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", isRequired: true, default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "Sort on A/C no", name: "isSortOnAcNo", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Print Entry Time", name: "isPrintEntryTime", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "transaction_type", width: "col-sm-2", options: [{
        label: "All",
        value: "All"
      },
      {
        label: "Cash",
        value: "Cash"
      }, {
        label: "Transfer",
        value: "Transfer"
      }, {
        label: "Clearing",
        value: "Clearing"
      }]
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "Print CIN", name: "isPrintCIN", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Print Entry By", name: "isPrintEntryBy", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Credit/Debit Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "credit_debit_type", width: "col-sm-2", options: [
        {
          label: "Credit",
          value: "Credit"
        }, {
          label: "Debit",
          value: "Debit"
        }, {
          label: "Both",
          value: "Both"
        }]
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "Regional Name", name: "isRegionalName", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Print Voucher Type", name: "isPrintVoucherType", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Voucher Type", width: "col-sm-2" }),
    ...controls.VoucherType({ tab: "filter" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "Print Particular", name: "isPrintParticular", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Scroll",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    clickable: false,
    displayColumns: [
      {
        Header: "Account Number",
        accessor: "account_number"
      },
      {
        Header: "Description",
        accessor: "description",
        width: 250,
        rwidth: "*"
      },
      {
        Header: "Batch",
        accessor: "batch_number"
      },
      {
        Header: "Vou",
        accessor: "voucher_number"
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "Cash",
            accessor: "credit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "credit_transfer",
            type: "currency"
          }
        ]
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Cash",
            accessor: "debit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "debit_transfer",
            type: "currency"
          }
        ]
      },
    ]
  }
};

export default rp003;
